import { LimitsBlockView, } from "./LimitsBlockView.tsx";
import { useModeratorStore, } from "../../../../../store/moderatorStore.ts";

export function LimitsBlockModerator() {
  const limits = useModeratorStore(state => state.limitsConfirmed,);

  return (
    <LimitsBlockView
      hasData={true}
      isLoading={false}
      data={limits}
      showLimitPage={false}
      cursorType="default"
    />
  );
}
